import {jarallax} from "jarallax";

export default (el) => {
  jarallax(document.querySelectorAll('.jarallax-choose'), {
    speed: 0.2,
  });
}
